(function () {
    'use strict';

    angular
        .module('app')
        .factory('alert', alertFactory);

    alertFactory.$inject = ['$templateRequest', '$sce', '$compile', '$rootScope', '$q', 'global', '$injector', 'helpers',];

    function alertFactory($templateRequest, $sce, $compile, $rootScope, $q, global, $injector, helpers) {
        var service = {
            open: openAlert,
            confirm: openConfirm,
            prompt: openPrompt,
            parentalGate: openParentalGate,
            modalStack: [],
        };

        return service;


        function openAlert(name, placeholders) {
            return $q(function (resolve) {
                var templateUrl = $sce.getTrustedResourceUrl('/templates/modal/alert/' + name + '.html');

                $templateRequest(templateUrl)
                    .then(function (template) {
                        var scope = $rootScope.$new();
                        scope.showAlert = false;
                        scope.name = 'alert-' + name;
                        scope.placeholders = placeholders;
                        scope.close = function () {
                            popModal();
                            scope.closeAlert();
                            resolve();
                        };

                        scope.isStage = global.site === 'stage';

                        scope.showAppDebug = function () {
                            var auth = $injector.get('auth');

                            auth.redirectToApp('onAppDebug');
                        };

                        angular.element(document.body)
                            .append($compile(template)(scope));

                        pushModal({ url: templateUrl, selector: scope.name });
                    });
            });
        }

        function openConfirm(name, placeholders) {
            return $q(function (resolve, reject) {
                var templateUrl = $sce.getTrustedResourceUrl('/templates/modal/confirm/' + name + '.html');

                $templateRequest(templateUrl)
                    .then(function (template) {
                        var scope = $rootScope.$new();
                        scope.showAlert = false;
                        scope.name = 'confirm-' + name;
                        scope.placeholders = placeholders;
                        scope.yes = function () {
                            popModal();
                            scope.closeAlert();
                            resolve();
                        };

                        scope.no = function () {
                            popModal();
                            scope.closeAlert();
                            reject();
                        };


                        angular.element(document.body)
                            .append($compile(template)(scope));

                        pushModal({ url: templateUrl, selector: scope.name });
                    });
            });
        }

        function openPrompt(name, placeholders) {
            return $q(function (resolve, reject) {
                var templateUrl = $sce.getTrustedResourceUrl('/templates/modal/prompt/' + name + '.html');

                $templateRequest(templateUrl)
                    .then(function (template) {
                        var scope = $rootScope.$new();
                        scope.showAlert = false;
                        scope.name = 'prompt-' + name;
                        scope.placeholders = placeholders;
                        scope.submit = function (formData) {
                            popModal();
                            scope.closeAlert();
                            resolve(formData);
                        };

                        scope.cancel = function () {
                            popModal();
                            scope.closeAlert();
                            reject();
                        };


                        angular.element(document.body)
                            .append($compile(template)(scope));

                        pushModal({ url: templateUrl, selector: scope.name });
                    });
            });
        }

        function openParentalGate(data) {
            return $q(function (resolve, reject) {
                var templateUrl = $sce.getTrustedResourceUrl('/templates/modal/gate/parental-gate.html');

                $templateRequest(templateUrl)
                    .then(function (template) {
                        var scope = $rootScope.$new();
                        scope.name = 'parent-gate';
                        scope.data = data;
                        scope.success = function () {
                            resolve();
                        };

                        scope.fail = function () {
                            reject();
                        };

                        var compiled = $compile(template)(scope, function(clonedElement, scope) {
                            clonedElement.attr('id', scope.name);
                            scope.removeParentalGate = function () {
                                popModal();
                                clonedElement.remove();
                                scope.$destroy();
                            };
                        });


                        angular.element(document.body)
                            .append(compiled);

                        pushModal({ url: templateUrl, selector: scope.name });
                    });
            });
        }

        function pushModal(modal) {
            service.modalStack.push(modal);
            helpers.lockScroll(modal.selector);
        }

        function popModal() {
            var poppedModal = service.modalStack.pop();
            helpers.unlockScroll(poppedModal.selector);

            /* Lock the scroll to the top most open modal */
            if (service.modalStack.length) {
                helpers.lockScroll(service.modalStack[service.modalStack.length - 1].selector);
            }
        }
    }
})();